// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__chat_container_direct {
  background-color: #262626;
  width: 444px;
  height: calc(100vh - 127px);
  position: fixed;
  bottom: 0px;
  right: 0;
  z-index: 1;
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.1019607843);
  border-radius: 10px 10px 0 0;
}
@media (max-width: 576px) {
  .__chat_container_direct {
    width: 100%;
  }
}
.__chat_container_direct .__chat {
  position: relative;
  width: 372px;
  height: 100%;
  background-color: #171515;
  border-radius: 10px 0 0 0;
  border-right: 1px solid rgba(255, 255, 255, 0.1019607843);
}
@media (max-width: 576px) {
  .__chat_container_direct .__chat {
    width: 90%;
    left: 0;
  }
}
.__chat_container_direct .__chat .__chat_header {
  border-radius: 10px 10px 0 0;
  background-color: #171515;
  padding: 16px 16px 10px;
}
.__chat_container_direct .__chat .__chat_header .__chat_header_divider {
  margin-top: 15px;
}
.__chat_container_direct .__chat .__chat_typing {
  position: absolute;
  bottom: 44px;
  padding: 0 16px;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3019607843);
}
.__chat_container_direct .__chat .__chat_typing .__typing {
  color: #BDBDBD;
  font-style: italic;
  font-size: 12px;
}
.__chat_container_direct .__chat ._chat_tippers_icon {
  position: absolute;
  right: 0;
  z-index: 1;
  cursor: pointer;
}
.__chat_container_direct .__chat .__chat_messages {
  position: absolute;
  width: calc(100% - 32px);
  height: calc(100% - 118px);
  overflow: scroll;
  position: relative;
  padding: 16px;
  top: 0px;
}
.__chat_container_direct .__chat .__chat_send {
  background-color: #171515;
  box-shadow: 0px -6px 12px rgba(0, 0, 0, 0.3019607843);
  width: 100%;
  height: 44px;
  padding-left: 16px;
  position: absolute;
  bottom: 0;
  border-radius: 0 0 10px 10px;
}
.__chat_container_direct .__chat .__chat_send .__chat_tip {
  width: 26px;
}
.__chat_container_direct .__chat .__chat_send .__chat_input {
  border: 0px !important;
  border-radius: 0 !important;
  border-color: none !important;
  background: transparent;
  resize: none;
  padding: 14px 0;
  width: 90%;
  color: #ffffff;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}
.__chat_container_direct .__chat .__chat_send .__chat_input:focus {
  outline: none !important;
}
.__chat_container_direct .__chat .__chat_send .__sent_botton {
  width: 20px;
  padding-right: 10px;
  cursor: pointer;
}
.__chat_container_direct .__chat_user_container {
  width: 72px;
  background-color: #171515;
  border-radius: 0 10px 0 0;
  position: relative;
}
@media (max-width: 576px) {
  .__chat_container_direct .__chat_user_container {
    width: 10%;
  }
}
.__chat_container_direct .__chat_user_container .__chat_user_box {
  overflow: scroll;
  max-height: 75%;
  width: 48px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: auto;
  position: absolute;
  bottom: 70px;
  right: 0;
  left: 0;
}
@media (max-width: 576px) {
  .__chat_container_direct .__chat_user_container .__chat_user_box {
    width: 30px !important;
  }
}
.__chat_container_direct .__chat_user_container .__chat_user_box .__chat_user_box_user {
  position: relative;
  width: 44px;
  height: 44px;
  cursor: pointer;
}
@media (max-width: 576px) {
  .__chat_container_direct .__chat_user_container .__chat_user_box .__chat_user_box_user {
    width: 30px !important;
    height: 30px !important;
  }
}
.__chat_container_direct .__chat_user_container .__chat_user_box .__chat_user_box_user .__chat_user_online {
  width: 8px;
  height: 8px;
  position: absolute;
  right: 0px;
  bottom: 4px;
  border-radius: 50%;
  border: 2px solid;
}
.__chat_container_direct .__chat_user_container .__chat_user_box .__chat_user_box_user .__chat_user_online_count {
  right: -4px;
  position: absolute;
  border-radius: 50%;
  top: 0;
  background: #E3293E;
  border: 0;
  width: 18px;
  height: 18px;
  text-align: center;
  font-size: 11px;
  font-weight: bold;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.__chat_container_direct .__chat_user_container .___ {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: auto;
  position: absolute;
  bottom: 12px;
  right: 0;
  left: 0;
  width: 44px;
}
@media (max-width: 576px) {
  .__chat_container_direct .__chat_user_container .___ {
    width: 30px !important;
  }
}
.__chat_container_direct .__chat_user_container .___ .__chat_user_new {
  cursor: pointer;
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid #999999;
}
@media (max-width: 576px) {
  .__chat_container_direct .__chat_user_container .___ .__chat_user_new {
    width: 30px !important;
    height: 30px !important;
  }
}
.__chat_container_direct .__chat_user_container .___ .__chat_user_new .__chat_add {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  font-size: 28px;
}
.__chat_container_direct .__chat_userlist_container {
  z-index: 10000;
  position: absolute;
  top: 0;
  width: 371px;
  height: 85%;
  background-color: #171515;
  border-radius: 10px 0 0 0;
  border-right: 1px solid rgba(255, 255, 255, 0.1019607843);
}
@media (max-width: 576px) {
  .__chat_container_direct .__chat_userlist_container {
    width: 100%;
  }
}
.__chat_container_direct .__chat_userlist_container .__chat_userlist_header {
  border-radius: 10px 10px 0 0;
  background-color: #171515;
  padding: 16px 16px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 10px 0 0px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1019607843);
}
.__chat_container_direct .__chat_userlist_container ._chat_user_search {
  position: relative;
  background-color: #343434;
  height: 30px;
  width: 93%;
  margin: auto;
  border-radius: 6px;
  margin-top: 10px;
}
.__chat_container_direct .__chat_userlist_container ._chat_user_search ._chat_user_search_input {
  width: inherit;
  color: #999999;
  background-color: #343434;
  border: 0;
  padding: 0;
  height: inherit;
  padding: 0 10px;
  border-radius: 6px;
}
.__chat_container_direct .__chat_userlist_container ._chat_user_search ._chat_user_search_icon {
  position: absolute;
  right: 7.5px;
  background: #343434;
  height: inherit;
}

.__chat_tip_container,
._chat_onlineUsers,
.__chat_more_data {
  position: absolute;
  top: 0px;
  width: 100%;
  height: calc(100% - 0px);
}
.__chat_tip_container ._chat_tip_box_header,
.__chat_tip_container ._chat_onlineUsers_headers,
.__chat_tip_container .__chat_more_data_header,
._chat_onlineUsers ._chat_tip_box_header,
._chat_onlineUsers ._chat_onlineUsers_headers,
._chat_onlineUsers .__chat_more_data_header,
.__chat_more_data ._chat_tip_box_header,
.__chat_more_data ._chat_onlineUsers_headers,
.__chat_more_data .__chat_more_data_header {
  background: #171515;
  padding: 10px 16px 8px 16px;
  border-radius: 10px 10px 0 0;
}
.__chat_tip_container ._chat_tip_box_hide,
.__chat_tip_container ._chat_onlineUsers_box_hide,
._chat_onlineUsers ._chat_tip_box_hide,
._chat_onlineUsers ._chat_onlineUsers_box_hide,
.__chat_more_data ._chat_tip_box_hide,
.__chat_more_data ._chat_onlineUsers_box_hide {
  padding: 16px;
  height: 0px;
  background: #1e1e1e;
  transition: height 0.5s ease-out;
}
.__chat_tip_container ._chat_tip_box,
.__chat_tip_container ._chat_onlineUsers_box,
.__chat_tip_container .__chat_more_data_box,
._chat_onlineUsers ._chat_tip_box,
._chat_onlineUsers ._chat_onlineUsers_box,
._chat_onlineUsers .__chat_more_data_box,
.__chat_more_data ._chat_tip_box,
.__chat_more_data ._chat_onlineUsers_box,
.__chat_more_data .__chat_more_data_box {
  padding: 16px;
  height: calc(100% - 106px);
  overflow: scroll;
  background: #171515;
  transition: height 0.5s ease-in;
}
.__chat_tip_container ._chat_tip_box .__playlist_chat_song_selected,
.__chat_tip_container ._chat_onlineUsers_box .__playlist_chat_song_selected,
.__chat_tip_container .__chat_more_data_box .__playlist_chat_song_selected,
._chat_onlineUsers ._chat_tip_box .__playlist_chat_song_selected,
._chat_onlineUsers ._chat_onlineUsers_box .__playlist_chat_song_selected,
._chat_onlineUsers .__chat_more_data_box .__playlist_chat_song_selected,
.__chat_more_data ._chat_tip_box .__playlist_chat_song_selected,
.__chat_more_data ._chat_onlineUsers_box .__playlist_chat_song_selected,
.__chat_more_data .__chat_more_data_box .__playlist_chat_song_selected {
  background: #3a3a3a;
  padding: 5px 0;
}

emoji-picker {
  position: absolute;
  z-index: 10;
  bottom: 3em;
}

._nft_list_gift {
  height: 85%;
}
@media (max-width: 576px) {
  ._nft_list_gift {
    height: 60%;
    width: 100%;
  }
}

._nft_fractions {
  position: absolute;
  width: 444px;
  height: 405px;
  background: #1E1E1E;
  top: 0;
  left: -477px;
  top: -124px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 16px;
  padding: 16px;
}
@media (max-width: 576px) {
  ._nft_fractions {
    z-index: 1000000000;
    width: 92%;
    top: -178px;
    left: 0;
    height: 147px;
  }
}
._nft_fractions ._nft_fractions_box {
  display: grid;
  grid-template-columns: 10% 10% 10% 10% 10% 10% 10% 10% 10% 10%;
  overflow: scroll;
  max-height: 87%;
  margin-top: 34px;
}
._nft_fractions ._nft_fractions_box ._fraction {
  width: 30px;
  height: 30px;
  font-size: 17px;
  color: #ffffff;
  cursor: pointer;
  border-radius: 50%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 12px;
}
._nft_fractions ._nft_fractions_box ._fraction:hover {
  background-color: rgba(244, 228, 44, 0.1882352941);
  color: #FFFFFF;
}
._nft_fractions ._nft_fractions_box ._fraction_selected {
  color: #1E1E1E;
  background: #FFEE20;
}
._nft_fractions ._nft_fractions_box ._fraction_selected:hover {
  color: #1E1E1E;
  background: #FFEE20;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/DirectChat/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACI,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,mDAAA;EACA,4BAAA;AA4BJ;ADHE;ECnCF;IAaQ,WAAA;EA6BN;AACF;AA3BI;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,yDAAA;AA6BR;ADhBE;ECnBE;IASQ,UAAA;IACA,OAAA;EA8BV;AACF;AA5BQ;EACI,4BAAA;EACA,yBAAA;EACA,uBAAA;AA8BZ;AA5BY;EACI,gBAAA;AA8BhB;AA1BQ;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,6CAAA;AA4BZ;AA1BY;EACI,cAAA;EACA,kBAAA;EAGA,eAAA;AA0BhB;AAtBQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAwBZ;AArBQ;EACI,kBAAA;EACA,wBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;AAuBZ;AApBQ;EACI,yBAAA;EAEA,qDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,4BAAA;AAqBZ;AAnBY;EACI,WAAA;AAqBhB;AAjBY;EACI,sBAAA;EACA,2BAAA;EACA,6BAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EAMA,uDAAA;AAchB;AAlBgB;EACI,wBAAA;AAoBpB;AAXY;EACI,WAAA;EACA,mBAAA;EACA,eAAA;AAahB;AARI;EACI,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAUR;AD/FE;ECiFE;IAOQ,UAAA;EAWV;AACF;AATQ;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,OAAA;AAWZ;ADjHE;EC2FM;IAcQ,sBAAA;EAYd;AACF;AAVY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAYhB;AD5HE;EC4GU;IAOQ,sBAAA;IACA,uBAAA;EAalB;AACF;AAXgB;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAapB;AATgB;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAWpB;AAHQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;AAKZ;ADvKE;ECyJM;IAYQ,sBAAA;EAMd;AACF;AAJY;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAMhB;ADpLE;ECwKU;IASQ,sBAAA;IACA,uBAAA;EAOlB;AACF;AALgB;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;AAOpB;AAAI;EACI,cAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,yDAAA;AAER;AD7ME;ECmME;IAWQ,WAAA;EAGV;AACF;AADQ;EACI,4BAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,2BAAA;EACA,0DAAA;AAGZ;AAAQ;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EAEA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AACZ;AACY;EACI,cAAA;EACA,cAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAChB;AAEY;EACI,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAAhB;;AAQA;;;EAGI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;AALJ;AAOI;;;;;;;;;EAGI,mBAAA;EACA,2BAAA;EACA,4BAAA;AACR;AAEI;;;;;;EAEI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;AAIR;AADI;;;;;;;;;EAGI,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AASR;AAPQ;;;;;;;;;EACI,mBAAA;EACA,cAAA;AAiBZ;;AAZA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;AAeJ;;AAZA;EACI,WAAA;AAeJ;AD3TE;EC2SF;IAIQ,WAAA;IACA,WAAA;EAgBN;AACF;;AAbA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,mDAAA;EACA,mBAAA;EACA,aAAA;AAgBJ;AD9UE;ECoTF;IAaQ,mBAAA;IACA,UAAA;IACA,WAAA;IACA,OAAA;IACA,aAAA;EAiBN;AACF;AAbI;EACI,aAAA;EACA,8DAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAeR;AAbQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AAeZ;AAbY;EACI,kDAAA;EACA,cAAA;AAehB;AAXQ;EACI,cAAA;EACA,mBAAA;AAaZ;AAXY;EACI,cAAA;EACA,mBAAA;AAahB","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n.__chat_container_direct {\n    background-color: #262626;\n    width: 444px;\n    height: calc(100vh - 127px);\n    position: fixed;\n    bottom: 0px;\n    right: 0;\n    z-index: 1;\n    display: flex;\n    border: 1px solid #FFFFFF1A;\n    border-radius: 10px 10px 0 0;\n\n    @include sm {\n        width: 100%;\n    }\n\n    .__chat {\n        position: relative;\n        width: 372px;\n        height: 100%;\n        background-color: #171515;\n        border-radius: 10px 0 0 0;\n        border-right: 1px solid #FFFFFF1A;\n\n        @include sm {\n            width: 90%;\n            left: 0;\n        }\n\n        .__chat_header {\n            border-radius: 10px 10px 0 0;\n            background-color: #171515;\n            padding: 16px 16px 10px;\n\n            .__chat_header_divider {\n                margin-top: 15px;\n            }\n        }\n\n        .__chat_typing {\n            position: absolute;\n            bottom: 44px;\n            padding: 0 16px;\n            width: 100%;\n            background-color: #0000004d;\n\n            .__typing {\n                color: #BDBDBD;\n                font-style: italic;\n\n\n                font-size: 12px;\n            }\n        }\n\n        ._chat_tippers_icon {\n            position: absolute;\n            right: 0;\n            z-index: 1;\n            cursor: pointer;\n        }\n\n        .__chat_messages {\n            position: absolute;\n            width: calc(100% - 32px);\n            height: calc(100% - 118px);\n            overflow: scroll;\n            position: relative;\n            padding: 16px;\n            top: 0px;\n        }\n\n        .__chat_send {\n            background-color: #171515;\n\n            box-shadow: 0px -6px 12px #0000004d;\n            width: 100%;\n            height: 44px;\n            padding-left: 16px;\n            position: absolute;\n            bottom: 0;\n            border-radius: 0 0 10px 10px;\n\n            .__chat_tip {\n                width: 26px;\n\n            }\n\n            .__chat_input {\n                border: 0px !important;\n                border-radius: 0 !important;\n                border-color: none !important;\n                background: transparent;\n                resize: none;\n                padding: 14px 0;\n                width: 90%;\n                color: #ffffff;\n\n                &:focus {\n                    outline: none !important;\n                }\n\n                font-family: \"Roboto\",\n                \"Helvetica\",\n                \"Arial\",\n                sans-serif;\n            }\n\n            .__sent_botton {\n                width: 20px;\n                padding-right: 10px;\n                cursor: pointer;\n            }\n        }\n    }\n\n    .__chat_user_container {\n        width: 72px;\n        background-color: #171515;\n        border-radius: 0 10px 0 0;\n        position: relative;\n\n        @include sm {\n            width: 10%;\n        }\n\n        .__chat_user_box {\n            overflow: scroll;\n            max-height: 75%;\n            width: 48px;\n            display: flex;\n            flex-direction: column;\n            gap: 5px;\n            margin: auto;\n            position: absolute;\n            bottom: 70px;\n            right: 0;\n            left: 0;\n\n            @include sm {\n                width: 30px !important;\n            }\n\n            .__chat_user_box_user {\n                position: relative;\n                width: 44px;\n                height: 44px;\n                cursor: pointer;\n\n                @include sm {\n                    width: 30px !important;\n                    height: 30px !important;\n                }\n\n                .__chat_user_online {\n                    width: 8px;\n                    height: 8px;\n                    position: absolute;\n                    right: 0px;\n                    bottom: 4px;\n                    border-radius: 50%;\n                    border: 2px solid;\n\n                }\n\n                .__chat_user_online_count {\n                    right: -4px;\n                    position: absolute;\n                    border-radius: 50%;\n                    top: 0;\n                    background: #E3293E;\n                    border: 0;\n                    width: 18px;\n                    height: 18px;\n                    text-align: center;\n                    font-size: 11px;\n                    font-weight: bold;\n                    color: #fff;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n\n\n                }\n            }\n\n        }\n\n        .___ {\n            display: flex;\n            flex-direction: column;\n            gap: 5px;\n            margin: auto;\n            position: absolute;\n            bottom: 12px;\n            right: 0;\n            left: 0;\n            width: 44px;\n\n            @include sm {\n                width: 30px !important;\n            }\n\n            .__chat_user_new {\n                cursor: pointer;\n                position: relative;\n                width: 44px;\n                height: 44px;\n                border-radius: 50%;\n                border: 1px solid #999999;\n\n                @include sm {\n                    width: 30px !important;\n                    height: 30px !important;\n                }\n\n                .__chat_add {\n                    position: absolute;\n                    right: 0;\n                    left: 0;\n                    bottom: 0;\n                    top: 0;\n                    margin: auto;\n                    font-size: 28px;\n                }\n            }\n        }\n\n    }\n\n    .__chat_userlist_container {\n        z-index: 10000;\n        position: absolute;\n        top: 0;\n        width: 371px;\n        height: 85%;\n        background-color: #171515;\n        border-radius: 10px 0 0 0;\n        border-right: 1px solid #FFFFFF1A;\n\n        @include sm {\n            width: 100%;\n        }\n\n        .__chat_userlist_header {\n            border-radius: 10px 10px 0 0;\n            background-color: #171515;\n            padding: 16px 16px 10px;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            border-radius: 10px 0 0px 0;\n            border-bottom: 1px solid #FFFFFF1A;\n        }\n\n        ._chat_user_search {\n            position: relative;\n            background-color: #343434;\n            height: 30px;\n\n            width: 93%;\n            margin: auto;\n            border-radius: 6px;\n            margin-top: 10px;\n\n            ._chat_user_search_input {\n                width: inherit;\n                color: #999999;\n                background-color: #343434;\n                border: 0;\n                padding: 0;\n                height: inherit;\n                padding: 0 10px;\n                border-radius: 6px;\n            }\n\n            ._chat_user_search_icon {\n                position: absolute;\n                right: 7.5px;\n                background: #343434;\n                height: inherit;\n\n            }\n        }\n\n    }\n}\n\n.__chat_tip_container,\n._chat_onlineUsers,\n.__chat_more_data {\n    position: absolute;\n    top: 0px;\n    width: 100%;\n    height: calc(100% - 0px);\n\n    ._chat_tip_box_header,\n    ._chat_onlineUsers_headers,\n    .__chat_more_data_header {\n        background: #171515;\n        padding: 10px 16px 8px 16px;\n        border-radius: 10px 10px 0 0;\n    }\n\n    ._chat_tip_box_hide,\n    ._chat_onlineUsers_box_hide {\n        padding: 16px;\n        height: 0px;\n        background: #1e1e1e;\n        transition: height 0.5s ease-out;\n    }\n\n    ._chat_tip_box,\n    ._chat_onlineUsers_box,\n    .__chat_more_data_box {\n        padding: 16px;\n        height: calc(100% - 106px);\n        overflow: scroll;\n        background: #171515;\n        transition: height 0.5s ease-in;\n\n        .__playlist_chat_song_selected {\n            background: #3a3a3a;\n            padding: 5px 0;\n        }\n    }\n}\n\nemoji-picker {\n    position: absolute;\n    z-index: 10;\n    bottom: 3em;\n}\n\n._nft_list_gift {\n    height: 85%;\n\n    @include sm {\n        height: 60%;\n        width: 100%;\n    }\n}\n\n._nft_fractions {\n    position: absolute;\n    width: 444px;\n    height: 405px;\n    background: #1E1E1E;\n    top: 0;\n    left: -477px;\n    top: -124px;\n    box-shadow: 0px 3px 6px #00000029;\n    border-radius: 16px;\n    padding: 16px;\n\n    @include sm {\n        z-index: 1000000000;\n        width: 92%;\n        top: -178px;\n        left: 0;\n        height: 147px;\n    }\n\n    ._nft_fractions_header {}\n\n    ._nft_fractions_box {\n        display: grid;\n        grid-template-columns: 10% 10% 10% 10% 10% 10% 10% 10% 10% 10%;\n        overflow: scroll;\n        max-height: 87%;\n        margin-top: 34px;\n\n        ._fraction {\n            width: 30px;\n            height: 30px;\n            font-size: 17px;\n            color: #ffffff;\n            cursor: pointer;\n            border-radius: 50%;\n            margin: auto;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-weight: bold;\n            margin-bottom: 12px;\n\n            &:hover {\n                background-color: #F4E42C30;\n                color: #FFFFFF;\n            }\n        }\n\n        ._fraction_selected {\n            color: #1E1E1E;\n            background: #FFEE20;\n\n            &:hover {\n                color: #1E1E1E;\n                background: #FFEE20;\n            }\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
